module.exports = __webpack_public_path__ + "img/35.eed1e7a3.svg";